const initialState = {
  selected_firm: null,
  dashboardConfig: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SELECTED_FIRM": 
      return {
        ...state,
        selected_firm: action.payload
      };
    case "SET_DASHBOARD_CONFIG":
      return {
        ...state,
        dashboardConfig: action.payload,
      };
    

    default:
      return state;
  }
};

export default dashboardReducer;